//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import FieldMixin from './FieldMixin.js';
import SkuField from './SkuField.vue';
import { getProductName, getVendorCode } from '../utils';

export default {

	mixins: [FieldMixin],

	components: { SkuField },

	props: {
		view: {
			type: String,
			default: 'default'
		},
	},

	computed: {

		name()
		{
			return getProductName(this.row, this.product);
		},

		vendorCode()
		{
			const vendorCode = getVendorCode(this.row, this.product);
			return vendorCode ? BX.message('RS.B2BPORTAL.TABLE.COLS.ARTICLE').replace('#NUMBER#', vendorCode) : false;
		},

		brand()
		{
			return this.row.brand !== '' ?
				BX.message('RS.B2BPORTAL.TABLE.COLS.BRAND').replace('#BRAND#', this.row.brand)  : false;
		},

		hasSku()
		{
			return Object.keys(this.row.sku).length > 0;
		},

		preview()
		{
			return (this.product.preview || {}).SRC || (this.row.preview || {}).SRC;
		},

		previewThumbnail()
		{
			return ((this.product.previewThumbnail || this.row.previewThumbnail || {}).src) || this.preview;
		},

		usePreviewPicture()
		{
			return this.$store.getters[`${this.$root.$namespace}/isShowPreview`];
		},

		labels()
		{
			return this.row.labels;
		},

		hasSku()
		{
			return Object.keys(this.row.sku).length > 0;
		}

	},

	mounted()
	{
		this.initPreviewPopovers();
	},

	methods: {
		initPreviewPopovers()
		{
			if (this.usePreviewPicture)
			{
				$(this.$refs.preview).popover({
					trigger: 'hover',
					placement: 'right',
					boundary: 'window',
					html: true,
					content: () =>  `<img class="img-fluid" src="${this.preview}" />`,
					title: '',
				});

			}
		}
	},

	watch: {
		preview()
		{
			this.$nextTick(() => {
				this.initPreviewPopovers();
			});
		}
	}
}
